import { render } from "./HeaderCard.vue?vue&type=template&id=327e95de&scoped=true"
import script from "./HeaderCard.vue?vue&type=script&lang=js"
export * from "./HeaderCard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-327e95de"

export default script